<template>
  <div
    class="button b2"
    id="button-10"
    @click="handleSwitchClick"
    :class="{ active: isActive === true }"
  >
    <div class="knobs">
      <span>{{ label[0] }}</span>
      <span>{{ label[1] }}</span>
    </div>
    <div class="layer"></div>
  </div>
</template>

<script>
export default {
  name: "TogglerV2",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: Array,
      default: null
    }
  },
  created() {
    this.isActive = this.value;
  },
  data: () => ({
    isActive: false
  }),
  watch: {
    value(val) {
      this.isActive = val;
    }
  },
  methods: {
    handleSwitchClick() {
      this.isActive = !this.isActive;
      this.$emit("toggle");
    }
  }
};
</script>
<style lang="scss" scoped>
.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.button {
  position: relative;
  width: 217px;
  height: 40px;
  overflow: hidden;
}
.button.r,
.button.r .layer {
  border-radius: 100px;
}
.button.b2 {
  border-radius: 2px;
}
.checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}
.knobs {
  z-index: 2;
}
.layer {
  width: 100%;
  background-color: #d6d6d6;
  transition: 0.3s ease all;
  z-index: 1;
  border-radius: 5px;
}
#button-10 .knobs:before,
#button-10 .knobs:after,
#button-10 .knobs span {
  position: absolute;
  top: 4px;
  width: 85px;
  height: 31px;
  font-size: 10px;
  text-transform: uppercase;
  text-align: center;
  line-height: 1;
  padding: 9px 4px;
  border-radius: 2px;
  transition: 0.3s ease all;
  font-size: 14px;
}
#button-10 .knobs:before {
  content: "";
  left: 4px;
  background-color: #00b372;
  width: 85px;
  border-radius: 5px;
}
#button-10 .knobs span {
  display: inline-block;
  left: 4px;
  color: #fff;
  z-index: 1;
}
#button-10 .knobs span:nth-child(2) {
  right: 0px;
  left: auto;
  width: 115px;
}
#button-10.active .knobs span:nth-child(2) {
  color: #fff;
}
#button-10.active .knobs span {
  color: #4e4e4e;
}
#button-10.active .knobs:before {
  left: calc(100% - 110px);
  background-color: #f0913b;
  width: 105px;
}
#button-10.active .knobs:after {
  color: #fff;
}
</style>
